module.exports = __webpack_public_path__ + "img/fu1_mb.c39846a2.jpg";